import { render, staticRenderFns } from "./ExternalComponent.vue?vue&type=template&id=00dada32&scoped=true"
import script from "./ExternalComponent.vue?vue&type=script&lang=js"
export * from "./ExternalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dada32",
  null
  
)

export default component.exports